
var init = () => {
    var cookieName = "AgeGate"
    var element = document.getElementById('age-gate');

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var cookie = getCookie(cookieName);

    if (!cookie && window.location.hotsname !== 'admin.shopify.com') {

        element.classList.add('is-visible');
        const srcSet = element.querySelectorAll('[data-srcset]')

        for (var i = 0; i < srcSet.length; i++) {
            var srcI = srcSet[i].dataset.srcset;
            if (srcI) {
                srcSet[i].setAttribute("srcset", srcI);
            }
        }

        const src = element.querySelectorAll('[data-src]')

        for (var j = 0; j < src.length; j++) {
            var srcJ = src[j].dataset.src;
            if (srcJ) {
                src[j].src = srcJ // ("src", srcJ);
            }
        }

        document.getElementById('age-gate__img').addEventListener('load', function () {
            element.classList.add('is-loaded');
        });

    } else {
        element.remove();
    }

    function getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    var form = document.getElementById('age_gate_form');

    const dayInput = document.getElementById("age_gate_dd");
    const monthInput = document.getElementById("age_gate_mm");
    const yearInput = document.getElementById("age_gate_yyyy");

    if (!dayInput) {
        return
    }

    dayInput.addEventListener("input", (e) => {

        var val = e.target.value;

        if (val.length > 2) {
            dayInput.value = val.slice(0, 2);
        }

        if (val <= 31 && val.length == 2) {
            monthInput.focus();
        }

        if (val > 31) {
            dayInput.value = ''
        }
    });

    monthInput.addEventListener("input", (e) => {

        var val = e.target.value;

        if (val.length > 2) {
            monthInput.value = val.slice(0, 2);
        }

        if (val <= 12 && val.length == 2) {
            yearInput.focus();
        }

        if (val > 12) {
            monthInput.value = ''
        }
    });

    yearInput.addEventListener("input", (e) => {

        var val = e.target.value;

        if (val.length > 4) {
            yearInput.value = val.slice(0, 4);
        }

        if (val.length === 4 && val < 1900) {
            yearInput.value = ''
        }
    });

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        let day = dayInput.value;
        let month = monthInput.value;
        let year = yearInput.value;


        const dateString = `${year}/${month}/${day}`
        var age = getAge(dateString);

        if (age >= 18) {
            setCookie(cookieName, true, 365);
            element.classList.remove('is-visible');
        } else {
            document.getElementById('age_gate_error').classList.add('is-visible');
        }

    });
}

init();